import { Link } from "@/i18n/Link";
import React, { type ComponentProps } from "react";

type Props = ComponentProps<typeof Link> & {};

export const CategoryLink = ({ children, ...props }: Props) => {
	const originalHref = props.href;

	const url = new URL(originalHref.toString(), "https://vikingfootwear.com");

	// if (searchParams["items.name"]) {
	// 	const sizeParams = searchParams["items.name"];
	// 	const sizes = Array.isArray(sizeParams) ? sizeParams : [sizeParams];

	// 	sizes.forEach((size) => {
	// 		url.searchParams.append("items.name", size);
	// 	});.
	// }

	return (
		<Link {...props} href={`${url.pathname}${url.search}`}>
			{children}
		</Link>
	);
};
CategoryLink.displayName = "CategoryLink";
